import { CapoPlugin } from "/Users/nestoras/Documents/GitHub/colorize-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];